module.exports = __webpack_public_path__ + "static/media/random.7ee9a430.svg";